const names = {
	title: "Hello World",
	callerA: "Neolex_Client_Liaison",
	callerB: "Unknown"
};

export default names;
